const parser = new DOMParser();

export function parse(data){
    return parser.parseFromString(data, "text/html");
}

